import React, { forwardRef, useEffect, useState } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
import { format, parse, isValid } from 'date-fns';

registerLocale('es', es);

export const DatePickerABX = ({
    date,
    setDate,
    styles,
    classNameInput,
    keyDate,
    desactivado
}) => {
    const [internalDate, setInternalDate] = useState(null);

    const cambiarFecha = (date) => {
        const formattedDate = format(date, 'dd/MM/yyyy HH:mm:ss');
        keyDate ? setDate(keyDate, formattedDate) : setDate(formattedDate);
    };

    // Función para transformar la fecha al formato que espera el DatePicker
    const transformarFecha = (inputDate) => {
        if (!inputDate) return null;

        if (typeof inputDate === 'string') {
            // Intenta parsear el string "dd/MM/yyyy HH:mm:ss" a un objeto Date
            const parsedDate = parse(inputDate, 'dd/MM/yyyy HH:mm:ss', new Date());
            return isValid(parsedDate) ? parsedDate : null;
        }

        // Si ya es un objeto Date válido, no se hace nada
        if (inputDate instanceof Date && isValid(inputDate)) {
            return inputDate;
        }

        return null; // En caso de que no sea válido
    };

    useEffect(() => {
        setInternalDate(transformarFecha(date));
    }, [date]);

    const DateInput = forwardRef(({ value, onClick }, ref) => (
        <input
            onClick={onClick}
            ref={ref}
            className={` ${classNameInput ? classNameInput : ' bg-zinc-800 '} text-center text-white h-[30px] rounded px-4 w-[150px] focus:outline-none focus:ring-1 focus:ring-blue-500`}
            value={value || ''}
            style={styles}
            readOnly
        />
    ));

    return (
        <DatePicker
            locale="es"
            selected={internalDate}
            onChange={cambiarFecha}
            customInput={<DateInput />}
            dateFormat="dd/MM/yyyy HH:mm:ss"
            // showTimeSelect
            showTimeInput={true}
            timeFormat="HH:mm:ss"
            timeIntervals={1} // Intervalo de un minuto
            timeInputLabel="Hora:"
            popperClassName="custom-popper-datepicker"
            popperPlacement="bottom"
            disabled={desactivado ? true : false}
        />
    );
};